export default __webpack_public_path__ + "static/media/pullQuote2Orb.47bbce0c.svg";